import type { Client } from '../../api/client.js';
import { AVIS_NETTETE, MODELE_MEILLEURE_PHOTO } from './libelles.js';
import type { DocumentLakou, VersionDocument } from './types.js';

export type DecisionExamen = 'valider' | 'meilleure_photo' | 'refuser';

/** Examen d'une pièce par l'équipe : la route du contrat journalise l'audit et publie l'événement côté serveur. */
export function examinerPiece(client: Client, documentId: string, decision: DecisionExamen, motif?: string): Promise<DocumentLakou> {
  return client.appeler<DocumentLakou>('documents.examiner', {
    parametres: { documentId },
    corps: motif === undefined ? { decision } : { decision, reason: motif },
  });
}

/** Message pré-rédigé pour « Demander une meilleure photo » (CA-BRI-06b) : jamais le nom du mandant, signé du Cabinet. */
export function messageMeilleurePhoto({
  prenomHeritier,
  libellePiece,
  lien,
}: {
  prenomHeritier: string;
  libellePiece: string;
  lien: string;
}): string {
  const modele = lien === '' ? MODELE_MEILLEURE_PHOTO.texteSansLien : MODELE_MEILLEURE_PHOTO.texte;
  return modele.replace('{prenom}', prenomHeritier).replace('{piece}', libellePiece).replace('{lien}', lien);
}

/** Avis du contrôle automatique de netteté d'une photo (CA-BRI-06a), en une phrase pour l'équipe. */
export function avisNettete({ blurScore, readable }: VersionDocument['quality']): string {
  const { textes, seuilFlou } = AVIS_NETTETE;
  if (readable === false) return textes.illisible;
  if (readable === null && blurScore === null) return textes.inconnu;
  return blurScore !== null && blurScore >= seuilFlou ? textes.floueLisible : textes.nette;
}
